export const apiRoutes = {
  auth: {
    token: '/token/',
    tokenRefresh: '/token/refresh/',
    register: '/register/',
    user: '/user/',
    currentUser: '/users/me/'
  },
  agents: {
    list: '/agents/',
    detail: (id) => `/agents/${id}/`,
    profile: '/agents/agent-profile/',
    assignments: '/agent/assignments/',
    assignment: (id) => `/agent/assignments/${id}/`,
    assignmentSubmit: (id) => `/agent/assignments/${id}/submit/`,
    applications: '/agent-applications/',
    neighborhoods: '/agent-neighborhoods/',
    neighborhoodObservation: (id) => `/agent-neighborhoods/${id}/`,
    propertyAssignments: '/property-assignments/',
    propertyAssignmentAction: (id, action) => `/property-assignments/${id}/${action}/`,
    relations: '/owner-agent-relations/',
    relation: (id) => `/owner-agent-relations/${id}/`,
    rateAgent: (id) => `/owner-agent-relations/${id}/rate_agent/`,
    toggleRelationStatus: (id) => `/owner-agent-relations/${id}/toggle_status/`
  },
  agentCalendar: {
    events: '/agent/calendar/events/',
    event: (id) => `/agent/calendar/events/${id}/`,
    blackouts: '/agent/calendar/blackouts/',
    blackout: (id) => `/agent/calendar/blackouts/${id}/`
  },
  applications: {
    list: '/applications/',
    mine: '/applications/mine/',
    detail: (id) => `/applications/${id}/`,
    withdraw: (id) => `/applications/${id}/withdraw/`,
    documents: (id) => `/applications/${id}/documents/`,
    applicantAuth: '/agent-applicant-auth/'
  },
  dealbridge: {
    chatrooms: '/dealbridge/chatrooms/',
    chatroomMessages: (roomId) => `/dealbridge/chatrooms/${roomId}/messages/`,
    roomStatus: (roomId) => `/dealbridge/rooms/${roomId}/status/`,
    roomPostponedTime: (roomId) => `/dealbridge/rooms/${roomId}/set-postponed-time/`,
    offers: '/dealbridge/offers/',
    reservations: '/dealbridge/reservations/',
    transactions: '/dealbridge/transactions/',
    transaction: (transactionId) => `/dealbridge/transactions/${transactionId}/`,
    transactionTasks: (transactionId) => `/dealbridge/transactions/${transactionId}/tasks/`,
    transactionTaskAction: (taskId, action) => `/dealbridge/transaction-tasks/${taskId}/${action}/`,
    reservationAction: (reservationId, action) => `/dealbridge/reservations/${reservationId}/${action}/`,
    offerRevisionAction: (revisionId, action) => `/dealbridge/offer-revisions/${revisionId}/${action}/`
  },
  developers: {
    firms: '/developers/',
    firm: (id) => `/developers/${id}/`,
    mine: '/developers/mine/',
    applicantAuth: '/developer-applicant-auth/',
    documents: '/developer-documents/',
    firmDocuments: (id) => `/developers/${id}/documents/`,
    requestBasicVerification: (id) => `/developers/${id}/request-basic-verification/`,
    requestMediumVerification: (id) => `/developers/${id}/request-medium-verification/`,
    verificationCases: '/developer-verification-cases/',
    portfolioProjects: '/developer-portfolio-projects/',
    portfolioProject: (id) => `/developer-portfolio-projects/${id}/`,
    portfolioProjectDocuments: '/developer-project-documents/',
    portfolioProjectDocument: (id) => `/developer-project-documents/${id}/`,
    portfolioProjectNestedDocuments: (id) => `/developer-portfolio-projects/${id}/documents/`,
    customerReferences: '/developer-customer-references/',
    portfolioProjectCustomerReferences: (id) => `/developer-portfolio-projects/${id}/customer-references/`,
    platformProjects: '/developer-platform-projects/',
    platformProject: (id) => `/developer-platform-projects/${id}/`,
    platformProjectDocuments: '/developer-platform-project-documents/',
    platformProjectNestedDocuments: (id) => `/developer-platform-projects/${id}/documents/`,
    wizardStatus: (id) => `/developer-platform-projects/${id}/wizard-status/`,
    bulkCreateUnits: (id) => `/developer-platform-projects/${id}/units/bulk-create/`,
    applySalesTemplate: (id) => `/developer-platform-projects/${id}/sales-strategies/apply-template/`,
    createPresaleListings: (id) => `/developer-platform-projects/${id}/presale-listings/`,
    ensureConstructionSchedule: (id) => `/developer-platform-projects/${id}/ensure-construction-schedule/`,
    sections: '/developer-project-sections/',
    section: (id) => `/developer-project-sections/${id}/`,
    unitTemplates: '/developer-unit-templates/',
    unitTemplate: (id) => `/developer-unit-templates/${id}/`,
    unitTemplateRevisions: '/developer-unit-template-revisions/',
    publishUnitTemplateRevision: (id) => `/developer-unit-template-revisions/${id}/publish/`,
    unitTemplatePlan: (id) => `/developer-unit-template-revisions/${id}/plan/`,
    units: '/developer-project-units/',
    unit: (id) => `/developer-project-units/${id}/`,
    salesStrategyTemplates: '/developer-sales-strategy-templates/',
    salesStrategyTemplate: (id) => `/developer-sales-strategy-templates/${id}/`,
    unitSalesStrategies: '/developer-unit-sales-strategies/',
    unitSalesStrategy: (id) => `/developer-unit-sales-strategies/${id}/`,
    constructionSchedules: '/developer-construction-schedules/',
    constructionScheduleVersions: '/developer-construction-schedule-versions/',
    constructionScheduleVersion: (id) => `/developer-construction-schedule-versions/${id}/`,
    activateScheduleVersion: (id) => `/developer-construction-schedule-versions/${id}/activate/`,
    constructionActivities: '/developer-construction-activities/',
    constructionActivityCatalog: '/developer-construction-activities/catalog/',
    activityDependencies: '/developer-construction-activity-dependencies/',
    surveyForms: '/developer-survey-forms/',
    surveyVersions: '/developer-survey-versions/',
    surveyCampaigns: '/developer-survey-campaigns/',
    surveyResponses: '/developer-survey-responses/',
    surveySubmit: '/developer-survey-responses/submit/',
    surveyFieldResponse: '/developer-survey-responses/field-response/',
    ratings: '/developer-ratings/',
    ratingSnapshots: '/developer-rating-snapshots/'
  },
  chat: {
    message: '/chat/',
    sessionClose: '/chat/session/close/',
    sessionInit: '/chat/session/init/',
    featureMappings: '/chatbot-feature-mappings/',
    filterProperties: '/chatbot-matching/filter_properties/',
    matchByFeatures: '/chatbot-matching/match_by_features/'
  },
  geo: {
    features: '/geo-features/',
    zoningOptions: '/geo-features/zoning-options/',
    hcmFeatures: '/hcm-features/',
    parcelZoning: '/facilities-distance/parcel-zoning/',
    poisDistance: '/facilities-distance/pois/',
    hexScores: '/facilities-distance/hex-scores/',
    saveAnalysis: '/geospatial-analysis/save-analysis/',
    polygonIntersection: '/polygon-intersection/intersect/'
  },
  gisPlatform: {
    datasets: '/gis-platform/datasets/',
    features: (dataset, query = '') => `/gis-platform/datasets/${dataset}/features/${query}`,
    feature: (dataset, id) => `/gis-platform/datasets/${dataset}/features/${id}/`,
    featureValues: (dataset) => `/gis-platform/datasets/${dataset}/features/distinct-values/`,
    featureBatch: (dataset) => `/gis-platform/datasets/${dataset}/features/batch/`,
    rows: (dataset) => `/gis-platform/datasets/${dataset}/rows/`,
    row: (dataset, id) => `/gis-platform/datasets/${dataset}/rows/${id}/`,
    imports: '/gis-platform/imports/',
    importDetail: (id) => `/gis-platform/imports/${id}/`,
    importCommit: (id) => `/gis-platform/imports/${id}/commit/`,
    importCancel: (id) => `/gis-platform/imports/${id}/cancel/`,
    changeSets: '/gis-platform/change-sets/',
    changeSetApprove: (id) => `/gis-platform/change-sets/${id}/approve/`,
    changeSetReject: (id) => `/gis-platform/change-sets/${id}/reject/`,
    changeSetPublish: (id) => `/gis-platform/change-sets/${id}/publish/`,
    agentSubmissions: '/gis-platform/agent-submissions/',
    agentSubmissionApprove: (id) => `/gis-platform/agent-submissions/${id}/approve/`,
    agentSubmissionReject: (id) => `/gis-platform/agent-submissions/${id}/reject/`
  },
  listings: {
    list: '/listings/',
    detail: (id) => `/listings/${id}/`,
    publicList: '/public-properties/',
    publicDetail: (id) => `/public-properties/${id}/`,
    byProperty: (propertyId) => `/listings/?property=${propertyId}`,
    search: '/listings/search/',
    recommendations: '/listings/recommendations/',
    rentDetails: (id) => `/listings/${id}/rent-details/`,
    saleDetails: (id) => `/listings/${id}/sale-details/`,
    schedules: (id) => `/listings/${id}/schedules/`,
    schedule: (listingId, scheduleId) => `/listings/${listingId}/schedules/${scheduleId}/`
  },
  locations: {
    provinces: '/provinces/',
    provinceCities: (provinceId) => `/provinces/${provinceId}/cities/`,
    regions: '/regions/',
    regionsByCity: (cityId) => `/regions/?city=${cityId}`,
    regionNeighborhoods: (regionId) => `/regions/${regionId}/neighborhoods/`,
    neighborhoods: '/neighborhoods/',
    neighborhoodBoundary: (neighborhoodId) => `/neighborhoods/${neighborhoodId}/boundary/`,
    findNeighborhoodByPoint: '/neighborhoods/find_by_point/',
    neighborhoodSearch: (query) => `/neighborhoods/search/?q=${encodeURIComponent(query)}`,
    citySearch: (query) => `/cities/search/?q=${encodeURIComponent(query)}`,
    regionSearch: (query) => `/regions/search/?q=${encodeURIComponent(query)}`
  },
  poi: {
    types: '/pois/get_poi_types/',
    data: '/pois/get_pois_data/',
    details: (poiId) => `/pois/${poiId}/get_poi_details/`,
    nearProperty: '/pois/near_property/',
    create: '/pois/create_poi/',
    detail: (poiId) => `/pois/${poiId}/`,
    verify: (poiId) => `/pois/${poiId}/verify/`,
    remove: (poiId) => `/pois/${poiId}/remove/`
  },
  poiAdvanced: {
    category: '/pois/category/',
    search: '/pois/search/',
    clusters: '/pois/clusters/',
    recommendations: (propertyId) => `/pois/recommendations/${propertyId}/`
  },
  preferences: {
    list: '/preferences/',
    featuresByPreference: '/preference-features/by_preference/',
    bulkUpdateFeatures: '/preference-features/bulk_update/'
  },
  properties: {
    list: '/properties/',
    active: '/properties/active/',
    detail: (id) => `/properties/${id}/`,
    propertyTypes: '/property-types/',
    propertyTypesByUsage: (usageId) => `/property-types/?usage=${usageId}`,
    usages: '/usages/',
    amenities: '/amenities/',
    amenitiesForWizard: (propertyType) => `/amenities/?panel=property_wizard&property_type=${propertyType}`,
    amenitiesByPropertyTypeName: (propertyTypeName) => `/amenities/?panel=property_wizard&property_type_name=${encodeURIComponent(propertyTypeName)}`,
    myRented: '/properties/my_rented/',
    resolveOwner: '/properties/resolve-owner/',
    saveSelfNationalId: '/properties/save-self-national-id/',
    images: (propertyId) => `/properties/${propertyId}/images/`,
    image: (propertyId, photoId) => `/properties/${propertyId}/images/${photoId}/`,
    updatePrimaryImage: (propertyId, photoId) => `/properties/${propertyId}/images/${photoId}/update_primary/`,
    reorderImages: (propertyId) => `/properties/${propertyId}/images/reorder/`,
    createListing: (propertyId) => `/properties/${propertyId}/create_listing/`,
    saleListings: (propertyId) => `/properties/${propertyId}/sale-listings/`,
    rentListings: (propertyId) => `/properties/${propertyId}/rent-listings/`,
    wizardStep: (propertyId, step) => `/properties/${propertyId}/steps/${step}/`,
    ownerList: '/owners/',
    ownerDetail: (propertyId) => `/owners/${propertyId}/`
  },
  propertyWizard: {
    step: (propertyId, step) => `/properties/${propertyId}/steps/${step}/`,
    completeStep: (propertyId, step) => `/properties/${propertyId}/steps/${step}/complete/`,
    geospatialFetch: (propertyId) => `/properties/${propertyId}/steps/3-geo/fetch/`,
    skipStep: (propertyId) => `/properties/${propertyId}/steps/skip/`,
    plan: (propertyId) => `/properties/${propertyId}/steps/5-plan/`,
    deletePlan: (propertyId) => `/properties/${propertyId}/steps/5-plan/delete/`,
    listingChoice: (propertyId) => `/properties/${propertyId}/steps/6-listing/choice/`,
    summary: (propertyId) => `/properties/${propertyId}/steps/10-summary/`,
    summarise: (propertyId) => `/properties/${propertyId}/summarise/`,
    finalize: (propertyId) => `/properties/${propertyId}/steps/11-finalize/`
  },
  requests: {
    list: '/requests/',
    detail: (id) => `/requests/${id}/`,
    amenities: (id) => `/requests/${id}/amenities/`,
    geoFeatures: (id) => `/requests/${id}/geo_features/`,
    commuteAnchors: (id) => `/requests/${id}/commute-anchors/`,
    addCommuteAnchor: (id) => `/requests/${id}/commute-anchors/add/`,
    editCommuteAnchor: (id, anchorId) => `/requests/${id}/commute-anchors/${anchorId}/edit/`,
    removeCommuteAnchor: (id, anchorId) => `/requests/${id}/commute-anchors/${anchorId}/remove/`,
    submit: (id) => `/requests/${id}/submit/`,
    matches: (id) => `/requests/${id}/matches/`
  },
  users: {
    detail: (id) => `/users/${id}/`,
    me: '/users/me/',
    meFavorites: '/users/me/favorites/',
    meFavorite: (propertyId) => `/users/me/favorites/${propertyId}/`,
    meShowings: '/users/me/showings/',
    meRentedProperties: '/users/me/rented-properties/',
    favorites: '/favorites/',
    favorite: (propertyId) => `/favorites/${propertyId}/`,
    showings: '/showings/',
    showing: (id) => `/showings/${id}/`,
    scheduleShowing: (id) => `/showings/${id}/schedule/`,
    completeShowing: (id) => `/showings/${id}/complete/`,
    showingSurvey: (showingId) => `/showings/${showingId}/survey/`,
    reservations: '/reservations/',
    reservationOffers: (reservationId) => `/reservations/${reservationId}/offers/`
  },
  agentIssues: {
    list: '/agent-issues/',
    detail: (id) => `/agent-issues/${id}/`
  },
  surveys: {
    list: '/surveys/'
  },
  inspectionTasks: {
    list: '/inspection-tasks/',
    detail: (id) => `/inspection-tasks/${id}/`,
    visitingWindows: (id) => `/inspection-tasks/${id}/visiting-windows/`,
    visits: (id) => `/inspection-tasks/${id}/visits/`,
    claim: (id) => `/inspection-tasks/${id}/claim/`,
    start: (id) => `/inspection-tasks/${id}/start/`,
    inspection: (id) => `/inspection-tasks/${id}/inspection/`
  },
  visits: {
    cancel: (id) => `/visits/${id}/cancel/`
  },
  visitingSchedules: '/visiting-schedules/'
};

export const plantUmlRoutes = {
  base: '/plantuml',
  categories: '/categories/',
  category: (id) => `/categories/${id}/`,
  diagrams: '/diagrams/',
  diagram: (id) => `/diagrams/${id}/`,
  diagramDownload: (id) => `/diagrams/${id}/download/`,
  diagramRender: (id) => `/diagrams/${id}/render/`,
  diagramPreview: '/diagrams/preview/',
  diagramDuplicate: (id) => `/diagrams/${id}/duplicate/`,
  diagramVersions: (id) => `/diagrams/${id}/versions/`,
  diagramRevert: (id) => `/diagrams/${id}/revert/`,
  diagramStatistics: '/diagrams/statistics/',
  comments: '/comments/',
  comment: (id) => `/comments/${id}/`
};

export default apiRoutes;
